import {
  EventStateManager,
  PollingOptimisticEventStateSync,
} from "../../alias";
import { SyncAdapterProps, eventSyncAdapterFactory } from "../game";
import {
  LobbyCommand,
  LobbyState,
  lobbyReducer,
  lobbyUndoReducer,
} from "./lobbyReducer";

const oneHourDuration = 1000 * 60 * 60;

export type LobbySyncAdapterProps = Omit<SyncAdapterProps, "gameId">;

export const lobbyStateManagerFactory = (
  initState: LobbyState,
  { gameName, neo4jConfig }: LobbySyncAdapterProps
) => {
  const eventStateManager = new EventStateManager<LobbyState, LobbyCommand>(
    initState,
    lobbyReducer,
    undefined,
    lobbyUndoReducer
  );
  const eventSyncAdapter = eventSyncAdapterFactory<LobbyCommand>({
    gameId: "lobby",
    gameName: `${gameName} Lobby`,
    neo4jConfig,
  });
  const pollingSync = new PollingOptimisticEventStateSync(
    eventStateManager,
    eventSyncAdapter,
    2000,
    new Date().getTime() - oneHourDuration,
    (event) => eventStateManager.undo(event)
  );

  return { pollingSync };
};
